var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "reference-house-filter" }, [
    _vm._v("\n    " + _vm._s(_vm.label) + ": "),
    _c(
      "a",
      {
        staticClass: "reference-house-filter-toggle",
        attrs: { href: "#" },
        on: {
          click: function($event) {
            $event.preventDefault()
            _vm.toggleDropdown()
          }
        }
      },
      [
        _vm._v(_vm._s(_vm.currentProductName) + " "),
        _c("span", { class: ["glyphicon", _vm.toggleIconClass] })
      ]
    ),
    _vm._v(" "),
    _vm.dropdownVisible
      ? _c(
          "ul",
          { staticClass: "reference-house-filter-dropdown" },
          _vm._l(_vm.products, function(product) {
            return _c(
              "li",
              {
                key: product.id,
                staticClass: "reference-house-filter-dropdown-item"
              },
              [
                _c(
                  "a",
                  {
                    class: _vm.itemClassObject(product.id),
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.selectProduct(product)
                      }
                    }
                  },
                  [
                    _vm._v("\n                " + _vm._s(product.productName)),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", {
                      staticClass:
                        "reference-house-filter-dropdown-item-description",
                      domProps: {
                        innerHTML: _vm._s(_vm.getProductDescription(product.id))
                      }
                    })
                  ]
                )
              ]
            )
          })
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{}!./~/vue-loader/lib?{}!./assets/vue/houseModel/components/refHouseFilter.vue?vue&type=template&id=85fd2422&
// module id = 503
// module chunks = 0